import { render } from "./loader.vue?vue&type=template&id=4b1a2b4c"
const script = {}

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__